import l from "./_compareAscending.js";
var g = l;
function m(i, n, a) {
  for (var r = -1, t = i.criteria, c = n.criteria, o = t.length, p = a.length; ++r < o; ) {
    var e = g(t[r], c[r]);
    if (e) {
      if (r >= p)
        return e;
      var d = a[r];
      return e * (d == "desc" ? -1 : 1);
    }
  }
  return i.index - n.index;
}
var h = m;
export {
  h as default
};
//# sourceMappingURL=_compareMultiple.js.map
